function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#494BB5"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M16.8775 27.7477C16.8779 27.9934 16.9506 28.234 17.0869 28.4387L17.7544 29.4422C17.8685 29.6137 18.0232 29.7544 18.2047 29.8518C18.3863 29.9491 18.5891 30 18.795 30H21.2055C21.4115 30 21.6143 29.9491 21.7959 29.8518C21.9774 29.7544 22.1321 29.6137 22.2461 29.4422L22.9137 28.4387C23.05 28.234 23.1228 27.9936 23.1231 27.7477L23.1246 26.2497H16.8756L16.8775 27.7477ZM13.1252 16.8749C13.1252 18.6081 13.7678 20.1893 14.8268 21.3974C15.4721 22.1338 16.4814 23.672 16.8662 24.9696C16.8677 24.9798 16.8689 24.99 16.8705 25.0001H23.1297C23.1313 24.99 23.1325 24.9802 23.134 24.9696C23.5188 23.672 24.5281 22.1338 25.1734 21.3974C26.2324 20.1893 26.875 18.6081 26.875 16.8749C26.875 13.0707 23.7856 9.98831 19.9786 10C15.9939 10.0121 13.1252 13.241 13.1252 16.8749ZM20.0001 13.75C18.2771 13.75 16.8752 15.1519 16.8752 16.8749C16.8752 17.2202 16.5955 17.4999 16.2502 17.4999C15.9049 17.4999 15.6252 17.2202 15.6252 16.8749C15.6252 14.4624 17.5876 12.5 20.0001 12.5C20.3454 12.5 20.6251 12.7797 20.6251 13.125C20.6251 13.4703 20.3454 13.75 20.0001 13.75Z",
  fill: "white"
});

function SvgGoldenmind(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldenmind);
export default __webpack_public_path__ + "static/media/goldenmind.2c64975b.svg";
export { ForwardRef as ReactComponent };